import apiClient from "@/api/apiClient";
import { type ApiResourceConfig } from "@/utils/api";

const table = "deployments_to_workspaces";
const query =
  "*, deployment:deployments(*, workspace:workspaces!deployments_workspace_id_fkey(*)), workspace:workspaces(*)";
export const apiConfigDeploymentsToWorkspaces: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [
    "workspace_name",
    "deployment.name",
    "deployment.address_1",
    "deployment.address_2",
    "deployment.city",
    "deployment.country",
    "deployment.zipcode",
    "deployment.workspace.name",
    "deployment.workspace.address_1",
    "deployment.workspace.address_2",
    "deployment.workspace.city",
    "deployment.workspace.country",
    "deployment.workspace.zipcode",
    "workspace.name",
    "workspace.address_1",
    "workspace.address_2",
    "workspace.city",
    "workspace.country",
    "workspace.zipcode",
  ],
  sortables: [
    "workspace_name",
    "created_at",
    "updated_at",
    "deployment.name",
    "workspace.name",
    "deployment.workspace.name",
  ],
};

export async function getDeploymentsToWorkspaces() {
  const { data, error } = await apiClient
    .from(table)
    .select(query)
    .is("deployment.deleted_at", null)
    .is("workspace.deleted_at", null);
  if (error) throw error;
  return data;
}

export const deleteDeploymentToWorkspace = async ({
  workspace_id,
  deployment_id,
}: {
  workspace_id: string;
  deployment_id: string;
}) => {
  const { error, ...rest } = await apiClient.rpc("revoke_deployment_invitation", {
    _workspace_id: workspace_id,
    _deployment_id: deployment_id,
  });
  if (error) throw error;

  return { error, ...rest };
};
